import { configureStore } from '@reduxjs/toolkit'
import assets from './assets'
import currentUser from './user'

export const store = configureStore({
  reducer: {
    assets,
    currentUser,
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
